<div class="reversal-dialog">
  <div class="header">
    <span>Create Transaction Reversal</span>
    <button class="close-btn" type="button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="reversalForm" (ngSubmit)="onSubmit()">
    <div class="input-container">
      <div class="form-field">
        <app-text-input
          label="Destination Wallet Address"
          placeholder="Enter destination wallet address"
          type="text"
          formControlName="destinationWalletAddress"
          [isInvalid]="getFieldError('destinationWalletAddress', 'Destination Wallet Address') !== ''"
          [errorMessage]="getFieldError('destinationWalletAddress', 'Destination Wallet Address')"
        ></app-text-input>
      </div>
    </div>

    <div class="buttons">
      <app-button buttonVariant="dialog-secondary" buttonType="button" (buttonClick)="onClose()">Cancel</app-button>
      <app-button buttonVariant="dialog-primary" buttonType="submit" [state]="nextButtonState">
        Next
      </app-button>
    </div>
  </form>
</div>
